(function () {
    'use strict';

    /**
     * 
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('adminCrewBatchers')
        .service('AdminCrewBatchService', AdminCrewBatchService);

    function AdminCrewBatchService(CrewBatchFactory, RemoteService) {
        var self = this;

        var model={
            crewBatchSearchCriteria: CrewBatchFactory.getCrewBatchSearchRequest(),
            batchList:[],
            isElasticLoadingVisible:false
        };
        
        var statusList = [
              {title:'Active', value: 'ACT'},
              {title:'Inactive', value: 'INA'},
              {title:'All', value: null}
        ];

        self.setCrewBatchSearchCriteria = function (data) {
            var crewBatchSearch = CrewBatchFactory.getCrewBatchSearchRequest();
            crewBatchSearch.startPosition = data.startPosition;
            crewBatchSearch.pageSize = data.pageSize;
            crewBatchSearch.description = data.description;
            crewBatchSearch.crewBatchCode = data.crewBatchCode;
            
            crewBatchSearch.status = ( data.status == null ? null : data.status.value );
            
            model.crewBatchSearchCriteria = crewBatchSearch;
        };

        self.getCrewBatches = function(successFn, errorFn){
            RemoteService.searchCrewBatch(model.crewBatchSearchCriteria).then(
                function (response) {
                    if(response.success && !!response.batchList){
                    	var batchList = CrewBatchFactory.formattedCrewBatchCollection(response.batchList);
                        successFn(batchList,response.startPosition);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.getNewCrewBatch = function(){
        	return CrewBatchFactory.getNewCrewBatch();
        }
        
        
        self.saveCrewBatch = function (data, successFn, errorFn){
           var saveCrewBatch = CrewBatchFactory.populateSaveRequest(data);
           RemoteService.saveCrewBatch(saveCrewBatch).then(
               function (response) {
                   successFn(response);
               },
               function (error) {
                   errorFn(error.msg[0]);
               }
           );
        }

        
        self.deleteCrewBatch = function (data, successFn, errorFn) {
            var deleteCrewBatch = CrewBatchFactory.populateCrewBatchDeleteRequest(data);
            RemoteService.deleteCrewBatch(deleteCrewBatch).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.searchStatusOptions = function(){
        	return statusList;
        }
        
        self.formatGridRowData = function(data){
        	return CrewBatchFactory.formatGridRowData(data);
        }
        
    }
})();